export class CleanOldVersionsDialogState {
    constructor(
        public showDialog = false,
        public processGuid: string = "",
        public deletableProcessVersions: DeletableProcessVersions = {},
        public processesMarkedForDeletion: Record<string, number> = {}
    ) { }
}

export type DeletableProcessVersions = Record<string, Record<number, number>>
